import { Box, Typography } from '@mui/material';

import { Button } from '@octopus/ui/design-system';
import { BottomActionBar } from '@octopus/ui/shared-components';

export const PageActionBar = ({
  selectedCount,
  onCancel,
  onSimulate,
}: {
  selectedCount: number;
  onCancel: () => void;
  onSimulate: () => void;
}) => {
  if (selectedCount === 0) {
    return null;
  }

  return (
    <BottomActionBar sx={{ justifyContent: 'end', alignItems: 'center' }}>
      <Box display="flex" alignItems="center" gap={2}>
        <Typography sx={{ ml: 1 }} color="text.primary">
          {selectedCount === 1
            ? '1 colaborador selecionado'
            : `${selectedCount} colaboradores selecionados`}
        </Typography>
        <Button variantSemantic="secondary" onClick={onCancel}>
          Cancelar
        </Button>
        <Button variantSemantic="primary" onClick={onSimulate}>
          Simular rescisão
        </Button>
      </Box>
    </BottomActionBar>
  );
};
